// extracted by mini-css-extract-plugin
export default {"wrapper":"CancelPayment_wrapper__TFFnI","up":"CancelPayment_up__Tmwz-","content":"CancelPayment_content__zkS4O","buttons":"CancelPayment_buttons__nhppp"};